import {
  FIELD_AIR_CONDITIONER, FIELD_BUSINESS,
  FIELD_DISABLED_PEOPLE, FIELD_FAMILY,
  FIELD_MEETING_ROOM,
  FIELD_PARKING,
  FIELD_PETS_ALLOWED, FIELD_POOL, FIELD_SPORTS_HALL
} from './constants';

export default {
  amenities: {
    [FIELD_AIR_CONDITIONER]: {
      value: '8',
      icon: 'air_conditioner',
    },
    [FIELD_DISABLED_PEOPLE]: {
      value: '2',
      icon: 'REDUCEDMOBILITY',
    },
    [FIELD_MEETING_ROOM]: {
      value: '7',
      icon: 'MEETING',
    },
    // open24h: {},
    // breakfast: {},
    // laudary: {},
    // shop: {},
    // wifi: {},
    [FIELD_PARKING]: {
      value: '4',
      icon: 'PARKING',
    },
    [FIELD_PETS_ALLOWED]: {
      value: '3',
      icon: 'pets-simple',
    },
    [FIELD_POOL]: {
      value: '5',
      icon: 'POOLSERVICE',
    },
    [FIELD_SPORTS_HALL]: {
      value: '6',
      icon: 'FITNESS',
    },
  },
  hotelTypes: {
    [FIELD_BUSINESS]: {
      value: '1',
      icon: 'S_LUGGAGE',
    },
    [FIELD_FAMILY]: {
      value: '2',
      icon: 'PELUCHE',
    }
  }
}
